import * as TypeGraphQL from "type-graphql";
export var ModelVersionScalarFieldEnum;
(function (ModelVersionScalarFieldEnum) {
    ModelVersionScalarFieldEnum["id"] = "id";
    ModelVersionScalarFieldEnum["modelName"] = "modelName";
    ModelVersionScalarFieldEnum["version"] = "version";
    ModelVersionScalarFieldEnum["status"] = "status";
    ModelVersionScalarFieldEnum["parentVersionId"] = "parentVersionId";
    ModelVersionScalarFieldEnum["performanceAccuracy"] = "performanceAccuracy";
    ModelVersionScalarFieldEnum["performancePrecision"] = "performancePrecision";
    ModelVersionScalarFieldEnum["performanceRecall"] = "performanceRecall";
    ModelVersionScalarFieldEnum["performanceF1Score"] = "performanceF1Score";
    ModelVersionScalarFieldEnum["performanceAuc"] = "performanceAuc";
    ModelVersionScalarFieldEnum["performanceSharpeRatio"] = "performanceSharpeRatio";
    ModelVersionScalarFieldEnum["performanceMaxDrawdown"] = "performanceMaxDrawdown";
    ModelVersionScalarFieldEnum["performanceWinRate"] = "performanceWinRate";
    ModelVersionScalarFieldEnum["performanceAvgReturn"] = "performanceAvgReturn";
    ModelVersionScalarFieldEnum["performanceCalibrationScore"] = "performanceCalibrationScore";
    ModelVersionScalarFieldEnum["performanceStabilityScore"] = "performanceStabilityScore";
    ModelVersionScalarFieldEnum["validationCrossValidationScore"] = "validationCrossValidationScore";
    ModelVersionScalarFieldEnum["validationOutOfSamplePerformance"] = "validationOutOfSamplePerformance";
    ModelVersionScalarFieldEnum["validationBacktestResults"] = "validationBacktestResults";
    ModelVersionScalarFieldEnum["validationStatTestResults"] = "validationStatTestResults";
    ModelVersionScalarFieldEnum["deploymentEnvironment"] = "deploymentEnvironment";
    ModelVersionScalarFieldEnum["deploymentTrafficAllocation"] = "deploymentTrafficAllocation";
    ModelVersionScalarFieldEnum["deploymentRolloutStrategy"] = "deploymentRolloutStrategy";
    ModelVersionScalarFieldEnum["deploymentHealthCheckConfig"] = "deploymentHealthCheckConfig";
    ModelVersionScalarFieldEnum["trainingStartTime"] = "trainingStartTime";
    ModelVersionScalarFieldEnum["trainingEndTime"] = "trainingEndTime";
    ModelVersionScalarFieldEnum["trainingDuration"] = "trainingDuration";
    ModelVersionScalarFieldEnum["trainingDatasetSize"] = "trainingDatasetSize";
    ModelVersionScalarFieldEnum["trainingFeaturesUsed"] = "trainingFeaturesUsed";
    ModelVersionScalarFieldEnum["trainingHyperparameters"] = "trainingHyperparameters";
    ModelVersionScalarFieldEnum["trainingResourcePeakMemoryMB"] = "trainingResourcePeakMemoryMB";
    ModelVersionScalarFieldEnum["trainingResourceTotalCpuHours"] = "trainingResourceTotalCpuHours";
    ModelVersionScalarFieldEnum["trainingResourceGpuHours"] = "trainingResourceGpuHours";
    ModelVersionScalarFieldEnum["createdAt"] = "createdAt";
    ModelVersionScalarFieldEnum["updatedAt"] = "updatedAt";
    ModelVersionScalarFieldEnum["deployedAt"] = "deployedAt";
    ModelVersionScalarFieldEnum["deprecatedAt"] = "deprecatedAt";
})(ModelVersionScalarFieldEnum || (ModelVersionScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ModelVersionScalarFieldEnum, {
    name: "ModelVersionScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ModelVersionScalarFieldEnum.js.map